export default __webpack_public_path__ + "static/media/addShortcut-2-zh.697d574f.JPG";